var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forbidden_page_content_wrapper"},[_vm._m(0),_c('button',{staticClass:"redirect_btn",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v(" Go Back ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image_wrapper"},[_c('img',{attrs:{"src":require("@/assets/media/illustrations/error_forbidden.svg"),"alt":"error forbidden","width":"250","height":"250"}})])
}]

export { render, staticRenderFns }